import { z } from 'zod';

export const AuthStateSchema = z.enum(['loading', 'authenticated', 'unauthenticated']);
export type AuthState = z.infer<typeof AuthStateSchema>;

export const UserProfileSchema = z.object({
  id: z.string().min(1),
  email: z.string().email(),
  name: z.string().optional(),
});
export type UserProfile = z.infer<typeof UserProfileSchema>;

/**
 * JWT payload schema for Firebase ID tokens.
 * Only validates the fields we need for auth.
 */
export const JwtPayloadSchema = z.object({
  sub: z.string().min(1),
  email: z.string().email(),
  name: z.string().optional(),
  exp: z.number().optional(),
});
export type JwtPayload = z.infer<typeof JwtPayloadSchema>;

/**
 * Result type for operations that can fail.
 */
export type Result<T, E> =
  | { readonly ok: true; readonly value: T }
  | { readonly ok: false; readonly error: E };

/**
 * Session verification errors.
 */
export type SessionError =
  | { readonly kind: 'no_cookie' }
  | { readonly kind: 'invalid_token'; readonly message: string }
  | { readonly kind: 'expired' };
